import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

import { Typography } from '../../atoms';
import ErrorIcon from '../../icons/Error';
import InfoIcon from '../../icons/Info';
import SuccessIcon from '../../icons/Success';
import WarningIcon from '../../icons/Warning';

export interface AlertProps {
  className?: string;
  message: string[];
  severity?: 'warning' | 'info' | 'success' | 'error' | 'notice';
}

const useStyles = makeStyles((theme: Theme) => ({
  alert: {
    alignItems: 'center',
    display: 'inline-flex',
    padding: theme.spacing(2),

    '& svg': {
      marginRight: theme.spacing(1.5),
      color: theme.palette.common.white,
    },
    '&.error': {
      backgroundColor: theme.palette.error.main,
      '& .MuiTypography-root': {
        color: theme.palette.error.contrastText,
      },
    },
    '&.info': {
      backgroundColor: theme.palette.info.main,
      '& .MuiTypography-root': {
        color: theme.palette.info.contrastText,
      },
    },
    '&.notice': {
      backgroundColor: theme.palette.common.black,
      '& .MuiTypography-root': {
        color: theme.palette.common.white,
      },
    },
    '&.success': {
      backgroundColor: theme.palette.success.main,
      '& .MuiTypography-root': {
        color: theme.palette.success.contrastText,
      },
    },
    '&.warning': {
      backgroundColor: theme.palette.warning.main,
      '& .MuiTypography-root': {
        color: theme.palette.warning.contrastText,
      },
    },
  },
}));

export const Alert = (props: AlertProps): JSX.Element => {
  const { className = '', message, severity = 'notice' } = props;
  const classes = useStyles();

  let snackIcon: JSX.Element | null = null;
  switch (severity) {
    case 'success':
      snackIcon = <SuccessIcon />;
      break;
    case 'error':
      snackIcon = <ErrorIcon />;
      break;
    case 'warning':
      snackIcon = <WarningIcon />;
      break;
    case 'info':
      snackIcon = <InfoIcon />;
      break;
    default:
      snackIcon = null;
  }

  const AlertStyles = clsx(
    classes.alert,
    className && className,
    severity === 'error' && 'error',
    severity === 'info' && 'info',
    severity === 'notice' && 'notice',
    severity === 'success' && 'success',
    severity === 'warning' && 'warning',
  );

  return (
    <div className={AlertStyles}>
      {snackIcon}
      <Typography>{message}</Typography>
    </div>
  );
};
